<template>
  <div class="luckywheel-box">
    <div class="red-num-box" v-if="luckyRedNum>0">{{luckyRedNum}}</div>
    <a class="lucky-entrance" href="javascript:void(0)" @click="handleShowLuckyWheelView"></a>
  </div>
</template>
<script>
import store from "@/store/index";
import { setActIframeUrl } from "@/logic/src/common";
export default {
  name: "luckyWheel",
  data() {
    return {
      scale: false,
    };
  },
  computed: {
    luckyRedNum() {
      return store.state.app.luckyRedNum;
    },
  },
  methods: {
    handleShowLuckyWheelView(){
      setActIframeUrl(store.state.app.currentGameID);
    }
  }
};
</script>

<style lang="scss" scoped>
.luckywheel-box {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 999;
  .lucky-entrance {
    display: block;
    width: 0.94rem;
    height: 0.54rem;
    background-image: url(~@/assets/img/lucky-wheel/UI_luckywheel_icon.png);
    background-size: cover;
  }
  .red-num-box {
    position: absolute;
    width: 0.145rem;
    height: 0.145rem;
    display: block;
    background-image: url(~@/assets/img/lucky-wheel/UI_luckywheel_icon_RP.png);
    background-size: cover;
    right: 0.05rem;
    top: 0;
    font-size: 0.07rem;
    line-height: 0.145rem;
    color: #ffffff;
    text-align: center;
  }
}
@media all and (orientation: portrait) {
  .luckywheel-box {
    position: fixed;
    right: inherit;
    left: 0;
    .lucky-entrance {
      display: block;
      height: 0.94rem;
      width: 0.54rem;
      background-image: url(~@/assets/img/lucky-wheel/UI_luckywheel_icon2.png);
      background-size: cover;
    }
    .red-num-box {
      transform: rotate(90deg);
      right: 0;
      bottom: 0.05rem;
      top: inherit;
    }
  }
}
</style>